var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgBag(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9.5 4.5h-1V3a2.5 2.5 0 10-5 0v1.5h-1A2.503 2.503 0 000 7v2a2.5 2.5 0 001.5 2.288V12a.5.5 0 001 0v-.5h7v.5a.5.5 0 001 0v-.712A2.5 2.5 0 0012 9V7a2.503 2.503 0 00-2.5-2.5zM4.5 3a1.5 1.5 0 013 0v1.5h-3V3zM11 9a1.5 1.5 0 01-1.5 1.5h-7A1.5 1.5 0 011 9V7a1.5 1.5 0 011.5-1.5h7A1.5 1.5 0 0111 7v2zM8.5 7a.5.5 0 01-.5.5H4a.5.5 0 110-1h4a.5.5 0 01.5.5z",
    fill: "#fff"
  })));
}
export default SvgBag;